export function getBaseUrl() {
  return process.env.REACT_APP_API_URL || "http://localhost:4440";
}
